// Spanish is authored first and is the fallback/default language.
export const es = {
  common: {
    save: 'Guardar',
    saving: 'Guardando...',
    saved: 'Cambios guardados',
    saveError: 'No se pudieron guardar los cambios',
    unsavedChanges: 'Cambios sin guardar',
    unsavedPrompt: 'Guarda tus cambios o descartalos antes de salir de esta pagina.',
    keepEditing: 'Seguir editando',
    discardChanges: 'Descartar cambios',
    loading: 'Cargando...',
    language: 'Idioma',
    enabled: 'Activado',
    disabled: 'Desactivado',
    close: 'Cerrar',
    discard: 'Descartar',
    delete: 'Eliminar',
  },
  nav: {
    dashboard: 'Panel',
    analytics: 'Analitica',
    designer: 'Disenador del formulario',
    shippingRates: 'Metodos de envio',
    salesBooster: 'Potenciador de ventas',
    quantityOffers: 'Ofertas por cantidad',
    tracking: 'Pixeles de seguimiento',
    settings: 'Configuracion',
    appName: 'Releasit COD',
    collapse: 'Contraer',
    expand: 'Expandir',
  },
  shippingRates: {
    title: 'Metodos de envio',
    addRate: 'Agregar metodo',
    empty: 'Aun no creaste metodos de envio. Haz clic en "Agregar metodo" para empezar.',
    /**
     * What a pixel's row reports without being opened. Derived by `pixelStatus`, whose header
     * explains the ordering — `unsupported` before `failing` before `inactive`.
     */
    colName: 'Nombre',
    colPrice: 'Precio',
    colCondition: 'Condicion',
    colActions: 'Acciones',
    alwaysVisible: 'Sin condicion, siempre visible.',
    edit: 'Editar',
    rateName: 'Nombre del metodo',
    rateDescription: 'Descripcion del metodo',
    ratePrice: 'Precio del metodo',
    conditionsHeading: 'Condiciones del metodo',
    addCondition: 'Agregar condicion',
    conditionType: 'Tipo de condicion',
    conditionValue: 'Valor',
    product: 'Producto',
    selectProduct: 'Seleccionar producto',
    productCount: '{{count}} productos',
    ct_order_total_gte: 'Total del pedido mayor o igual que',
    ct_order_total_lt: 'Total del pedido menor que',
    ct_quantity_gte: 'Cantidad de productos mayor o igual que',
    ct_quantity_lt: 'Cantidad de productos menor que',
    ct_cart_contains_product: 'El carrito contiene el producto',
    ct_cart_not_contains_product: 'El carrito no contiene el producto',
    // Country gating is disabled (see ShippingRates.tsx). These four strings and
    // `countrySummary` below are kept, unused, so switching it back on needs no re-translation.
    countryOnly: 'Habilitar este metodo solo para paises especificos',
    countryCodes: 'Paises',
    addCountry: 'Agregar un pais...',
    countryCodesHelp: 'El metodo solo se muestra a compradores de los paises que elijas aqui.',
    lastRateHelp:
      'Tu tienda necesita al menos un metodo de envio, por eso no podes eliminar el ultimo.',
    conditionsSummary: '{{count}} condicion(es)',
    countrySummary: '{{count}} pais(es)',
  },
  quantityOffers: {
    title: 'Ofertas por cantidad',
    addOffer: 'Agregar oferta',
    search: 'Buscar',
    searchPlaceholder: 'Buscar por nombre...',
    priority: 'Prioridad',
    enabled: 'Activa',
    name: 'Nombre',
    actions: 'Acciones',
    newOfferName: 'Nueva oferta',
    emptyTitle: 'Configura tus ofertas por cantidad',
    emptyText:
      'Aqui podes crear ofertas por cantidad para tu formulario COD. Las ofertas se muestran directamente en el formulario o en la pagina del producto.',
    noResults: 'No se encontraron ofertas con ese nombre',
    noResultsText: 'Proba con otro nombre, o borra la busqueda para ver todas tus ofertas.',
    removedTitle: 'Todavia no eliminaste tus ofertas',
    removedText: 'Guarda para eliminarlas definitivamente, o descarta para recuperarlas.',
    edit: 'Editar',
    drag: 'Arrastrar para reordenar',
    duplicate: 'Duplicar',
    delete: 'Eliminar',
    copyLabel: 'Copia',
    conflictTitle: 'Revisa tus ofertas por cantidad',
    conflictWarning:
      'El producto {{product}} se usa en varias ofertas por cantidad. Revisalo, ya que solo se mostrara una y las demas no funcionaran.',
  },
  quantityOfferEditor: {
    addTitle: 'Agregar oferta',
    editTitle: 'Editar oferta',
    active: 'Activa',
    inactive: 'Inactiva',
    back: 'Volver',
    saveRequirement: 'Agrega un nombre de oferta y al menos un producto para guardar.',
    configureOffer: '1. Configura la oferta',
    offerName: 'Nombre de la oferta',
    offerNamePlaceholder: 'Nueva oferta',
    productsHeading: 'Crea ofertas por cantidad para estos productos:',
    selectProducts: 'Seleccionar productos',
    productId: 'ID del producto',
    removeProduct: 'Quitar producto',
    configureTiers: '2. Configura tus ofertas por cantidad',
    tableTitle: 'Titulo',
    tableQuantity: 'Cantidad',
    addTier: 'Agregar oferta',
    editTier: 'Editar oferta',
    deleteTier: 'Eliminar',
    selectProductPlaceholder: 'Seleccionar producto',
    defaultTierOne: 'Compra 1 unidad',
    defaultTierTwo: 'Compra 2 unidades y obtene 25% off!',
    defaultSaveZero: 'Ahorra 0%',
    tier: {
      title: 'Titulo',
      titleHelp:
        'Usa {product_name} para insertar dinamicamente el nombre del producto en este campo.',
      quantity: 'Cantidad',
      preselect: 'Preseleccionar esta oferta',
      bestDeal: 'Mostrar la insignia "Mejor oferta"',
      bestDealHelp:
        'La insignia se muestra junto a la placa de ahorro en la oferta preseleccionada, por lo que solo una oferta puede tenerla.',
      bestDealText: 'Texto de la insignia',
      bestDealBgColor: 'Color de fondo de la insignia',
      bestDealTextColor: 'Color del texto de la insignia',
      bestDealRadius: 'Radio del borde de la insignia',
      bestDealAnimation: 'Animacion de la insignia',
      hideComparePrice: 'Ocultar el precio comparativo en la oferta',
      discountType: 'Tipo de descuento',
      discountPercentage: 'Porcentaje',
      discountFixed: 'Monto fijo',
      discountNone: 'Sin descuento',
      discountValue: 'Valor del descuento',
      priceColor: 'Color del precio',
      plaqueText: 'Texto de la placa',
      plaqueTextColor: 'Color del texto de la placa',
      plaqueBgColor: 'Color de fondo de la placa',
      imageUrl: 'URL de la imagen',
    },
    design: {
      heading: '3. Personaliza el diseno y el comportamiento',
      selectMode: 'Selecciona el modo y la plantilla',
      displayAboveBuyButton: 'Mostrar sobre el boton de compra (solo en modo ventana emergente)',
      templateClassic: 'Clasico',
      templateModern: 'Moderno',
      templateVertical: 'Vertical',
      verticalLimitHelp:
        'La plantilla vertical muestra hasta {{max}} ofertas para que las tarjetas se vean bien.',
      verticalUnavailableHelp:
        'La plantilla vertical muestra solo {{max}} ofertas para que las tarjetas se vean bien. Tenes {{offers}}, asi que no se puede seleccionar: los compradores nunca podrian elegir las ofertas de mas. Elimina una oferta para poder usarla.',
      palette: 'Selecciona una paleta',
      bgColor: 'Color de fondo',
      borderColor: 'Color del borde',
      pricesSize: 'Tamano de los precios',
      borderRadius: 'Radio del borde',
      hideProductImage: 'Ocultar la imagen del producto',
      hideVariantNumbers:
        'Ocultar los numeros junto a los selectores de variante (si el producto tiene variantes)',
      disableVariantSelectors:
        'Desactivar los selectores de variante (si el producto tiene variantes)',
    },
  },
  productPicker: {
    title: 'Agregar productos',
    searchPlaceholder: 'Buscar productos',
    add: 'Agregar',
    cancel: 'Cancelar',
    selectedCount: '{{count}} productos seleccionados',
    loadMore: 'Cargar mas',
    loading: 'Cargando productos...',
    empty: 'No se encontraron productos.',
    error: 'No se pudieron cargar los productos.',
  },
  dashboard: {
    title: 'Panel',
    subtitle: 'Resumen de tu formulario de pago contra entrega',
    appStatus: 'Estado de la aplicacion',
    appStatusHelp: 'Activa o desactiva el formulario en toda tu tienda',
    formViews: 'Vistas del formulario',
    formOpens: 'Aperturas del formulario',
    ordersCreated: 'Pedidos creados',
    welcomeTitle: 'Releasit ya esta en Tiendanube',
    welcomeBody:
      'Tus compradores completan un formulario de pago contra entrega en la pagina del producto y se crea un pedido real en tu tienda.',
    welcomeCta: 'Personaliza tu formulario',
    setupTitle: 'Completa tu configuracion',
    setupDoneTitle: 'Configuracion completa',
    setupProgress: '{{done}} de {{total}} completados',
    setupHide: 'Ocultar',
    setupShow: 'Mostrar',
    stepOptional: 'Opcional',
    steps: {
      activate: {
        title: 'Activa la aplicacion',
        help: 'Mientras este desactivada, los compradores no ven el formulario.',
        action: 'Activar',
      },
      customize: {
        title: 'Personaliza tu formulario',
        help: 'Ajusta los campos, los textos y los colores a tu marca.',
        action: 'Personalizar',
      },
      shipping: {
        title: 'Configura los metodos de envio',
        help: 'Agrega al menos un metodo ademas del envio gratis inicial.',
        action: 'Configurar',
      },
      offer: {
        title: 'Crea una oferta por cantidad',
        help: 'Ofrece un descuento por comprar mas de una unidad.',
        action: 'Crear',
      },
      pixel: {
        title: 'Agrega un pixel de seguimiento',
        help: 'Envia tus conversiones contra entrega a tus plataformas de anuncios.',
        action: 'Agregar',
      },
      order: {
        title: 'Recibe tu primer pedido',
        help: 'Se marca solo cuando un comprador completa el formulario.',
        action: 'Ver analitica',
      },
    },
    liveTitle: 'Lo que esta activo ahora',
    liveVisibility: 'Visibilidad',
    liveMode: 'Modo de visualizacion',
    liveOffers: 'Ofertas por cantidad activas',
    livePixels: 'Pixeles activos',
    liveCoverage: 'Cobertura',
    liveCoverageOff: 'Desactivada',
    liveChange: 'Cambiar',
    modePopup: 'Ventana emergente',
    modeEmbedded: 'Integrado',
    lifetimeRevenue: 'Ingresos totales',
    noOrdersYet: 'Aun no hay pedidos',
    performanceTitle: 'Rendimiento total',
    avgOrder: '{{amount}} por pedido',
    recentOrders: 'Pedidos recientes',
    viewAllOrders: 'Ver todos los pedidos',
    scopeFix: 'Volver a autorizar la aplicacion',
    scope: {
      write_orders: {
        title: 'No se pueden crear pedidos',
        body: 'Tu tienda no le concedio a la aplicacion el permiso para crear pedidos, asi que cada envio del formulario falla. Actualiza el permiso y vuelve a autorizar la aplicacion.',
      },
      read_coupons: {
        title: 'No se pueden validar los codigos de descuento',
        body: 'Tu tienda no le concedio a la aplicacion el permiso para leer cupones, asi que los codigos de descuento del formulario siempre se rechazan. Actualiza el permiso y vuelve a autorizar la aplicacion.',
      },
    },
    offerConflictTitle: 'Ofertas por cantidad superpuestas',
    offerConflictBody:
      '"{{product}}" esta en mas de una oferta activa. Solo se muestra la de mayor prioridad.',
    offerConflictFix: 'Revisar las ofertas',
  },
  analytics: {
    title: 'Analitica',
    subtitle: 'Rendimiento de tu formulario contra entrega (en horario UTC)',
    dateRange: 'Rango de fechas',
    presets: {
      last7: 'Ultimos 7 dias',
      last30: 'Ultimos 30 dias',
      last90: 'Ultimos 90 dias',
      thisMonth: 'Este mes',
      custom: 'Personalizado',
    },
    from: 'Desde',
    to: 'Hasta',
    invalidRange: 'Elige una fecha de inicio anterior o igual a la de fin.',
    lifetimeTitle: 'Felicitaciones!',
    lifetimeBody: 'Tu formulario contra entrega genero {{amount}} en ingresos historicos.',
    formOpens: 'Aperturas del formulario',
    orders: 'Pedidos',
    conversionRate: 'Tasa de conversion',
    revenue: 'Ingresos',
    aov: 'Valor promedio del pedido',
    trendOpens: 'Aperturas a lo largo del tiempo',
    trendOrders: 'Pedidos a lo largo del tiempo',
    trendRevenue: 'Ingresos a lo largo del tiempo',
    noData: 'Aun no hay datos',
    tooltipOpens_one: '{{value}} apertura del formulario',
    tooltipOpens_other: '{{value}} aperturas del formulario',
    tooltipOrders_one: '{{value}} pedido',
    tooltipOrders_other: '{{value}} pedidos',
    quantityOffers: 'Ofertas por cantidad',
    qoSelections: 'Pedidos con una oferta',
    qoRevenue: 'Contribucion a los ingresos',
    qoDiscount: 'Descuento otorgado',
    qoNote:
      'La tasa de visualizacion y seleccion aparecera cuando se registren las impresiones de las ofertas.',
  },
  designer: {
    title: 'Disenador del formulario',
    subtitle: 'Personaliza y previsualiza tu formulario',
    mode: 'Modo de visualizacion',
    modePopup: 'Ventana emergente',
    modeEmbedded: 'Incrustado',
    popupNote:
      'Cuando tus clientes hagan clic en el <b>Boton de compra</b> de la app, el formulario se abrira como una ventana emergente en la pagina.',
    embeddedNote:
      'Tus clientes veran el formulario incrustado directamente en sus paginas, asi no tendran que hacer clic en ningun boton para abrirlo.',
    tabs: {
      button: 'Boton',
      fields: 'Campos',
      coverage: 'Cobertura',
      appearance: 'Apariencia',
      text: 'Textos',
    },
    coverage: {
      heading: 'Cobertura de envio',
      description:
        'Selecciona las regiones a las que entregas. Los campos de provincia, ciudad y codigo postal se convertiran en listas desplegables y se validaran al confirmar el pedido.',
      label: 'Cobertura',
      countryLabel: 'Pais donde vendes',
      countryHelp: 'Determina que coberturas estan disponibles abajo.',
      countryNone: 'Selecciona un pais',
      none: 'Sin cobertura',
      noneForCountry: 'Todavia no hay coberturas disponibles para {{country}}.',
      noneUnknownCountry:
        'No pudimos determinar el pais de tu tienda, por lo que no hay cobertura disponible.',
      appliesTo: 'Se aplica a',
      fieldProvince: 'Provincia',
      fieldCity: 'Ciudad',
      fieldPostal: 'Codigo postal',
    },
    button: {
      text: 'Texto del boton',
      bgColor: 'Color de fondo',
      textColor: 'Color del texto',
      borderRadius: 'Radio del borde',
      borderWidth: 'Grosor del borde',
      borderColor: 'Color del borde',
      icon: 'Icono',
      iconBag: 'Bolsa',
      iconCart: 'Carrito',
      iconNone: 'Sin icono',
    },
    fields: {
      heading: 'Campos del formulario',
      reorderHint: 'Arrastra para reordenar los campos. Abre un campo para editar sus opciones.',
      headerCard: 'Encabezado',
      fieldTitle: 'Campo: {{label}}',
      drag: 'Arrastrar para reordenar',
      hide: 'Ocultar campo',
      show: 'Mostrar campo',
      enabled: 'Visible',
      required: 'Obligatorio',
      showIcon: 'Mostrar icono del campo',
      label: 'Etiqueta',
      placeholder: 'Texto de ejemplo',
      coverageLocked:
        'Este campo forma parte de la cobertura que elegiste, asi que siempre se muestra. Sin el, el desplegable siguiente se queda vacio y la cobertura deja de validar los pedidos.',
      minLength: 'Longitud minima',
      maxLength: 'Longitud maxima',
      errorText: 'Texto de error de valor invalido',
      errorHelp:
        'Si dejas este campo vacio, la app usara tu <b>texto de error generico</b> cuando el cliente ingrese un valor invalido. Puedes editarlo en la pestana Textos.',
    },
    fieldsStyle: {
      heading: 'Estilo de los campos',
      hideLabels: 'Ocultar etiquetas de los campos',
      bgColor: 'Color de fondo del campo',
      textColor: 'Color del texto del campo',
      placeholderColor: 'Color del texto de ejemplo',
      borderColor: 'Color del borde',
      borderWidth: 'Grosor del borde',
      borderMode: 'Borde',
      noBorder: 'Sin borde',
      border: 'Con borde',
      borderPosition: 'Posicion del borde',
      posAll: 'Todos los lados',
      posTop: 'Arriba',
      posRight: 'Derecha',
      posBottom: 'Abajo',
      posLeft: 'Izquierda',
      borderRadius: 'Radio del borde',
      shadow: 'Sombra',
      sizing: 'Tamano',
    },
    appearance: {
      heading: 'Apariencia general',
      borderRadius: 'Radio del borde',
      bgColor: 'Color de fondo',
      textColor: 'Color del texto',
      accentColor: 'Color de acento',
    },
    productCard: {
      heading: 'Resumen del pedido',
      show: 'Mostrar resumen del pedido',
      bgColor: 'Color de fondo',
      borderColor: 'Color del borde',
      borderWidth: 'Grosor del borde',
      borderRadius: 'Radio del borde',
      hideQuantity: 'Ocultar controles de cantidad',
      qcBg: 'Fondo de los controles de cantidad',
      qcBorderColor: 'Color del borde de los controles',
      qcBorderWidth: 'Grosor del borde de los controles',
      qcBorderRadius: 'Radio del borde de los controles',
    },
    totals: {
      heading: 'Resumen de totales',
      show: 'Mostrar resumen de totales',
      subtotalTitle: 'Titulo de subtotal',
      shippingTitle: 'Titulo de envio',
      totalTitle: 'Titulo de total',
      showTaxes: 'Mostrar mensaje de impuestos',
      taxesMessage: 'Mensaje de impuestos',
      bgColor: 'Color de fondo',
      textColor: 'Color del texto',
      borderColor: 'Color del borde',
      borderWidth: 'Grosor del borde',
      borderRadius: 'Radio del borde',
      dividerColor: 'Color del divisor',
      dividerWidth: 'Grosor del divisor',
    },
    discount: {
      lineText: 'Texto de la linea de descuentos',
      fieldLabel: 'Etiqueta del campo de codigo',
      applyText: 'Texto del boton Aplicar',
      buttonBg: 'Color de fondo del boton Aplicar',
      buttonText: 'Color del texto',
      borderColor: 'Color del borde',
      borderRadius: 'Radio del borde',
      borderWidth: 'Grosor del borde',
      inputBg: 'Color de fondo del campo',
      inputText: 'Color del texto del campo',
      inputBorderColor: 'Color del borde del campo',
      inputPlaceholderColor: 'Color del texto de ejemplo',
      inputBorderRadius: 'Radio del borde del campo',
      inputBorderWidth: 'Grosor del borde del campo',
      invalidError: 'Texto de error de codigo invalido',
    },
    shipping: {
      freeText: 'Texto para envio gratis (si un metodo es gratuito)',
      bgColor: 'Color de fondo',
      textColor: 'Color del texto',
      borderColor: 'Color del borde',
      activeBorderColor: 'Color del borde activo',
      borderWidth: 'Grosor del borde',
      borderRadius: 'Radio del borde',
    },
    /**
     * Inline validation shown on the control that blocks a save. Derived from the schema by
     * `designer/validation.ts`, so a bound quoted here is the bound the backend enforces.
     */
    validation: {
      empty: 'Este campo no puede quedar vacio.',
      minChars: 'Debe tener al menos {{min}} caracteres.',
      maxChars: 'No puede superar los {{max}} caracteres.',
      minValue: 'El valor minimo es {{min}}.',
      maxValue: 'El valor maximo es {{max}}.',
      minItems: 'Debe haber al menos {{min}}.',
      invalid: 'Este valor no es valido.',
      saveBlocked: 'Revisa los campos marcados en rojo.',
      saveBlockedElsewhere:
        'Una configuracion invalida esta bloqueando el guardado, pero no se edita en esta vista.',
    },
    text: {
      headerTitle: 'Titulo del formulario',
      headerIcon: 'Mostrar icono',
      summarySection: 'Resumen del pedido',
      shippingLabel: 'Texto del envio',
      showDiscount: 'Mostrar codigo de descuento',
      shippingMethodSection: 'Metodo de envio',
      shippingMethodTitle: 'Titulo de la seccion',
      shippingMethodOption: 'Nombre de la opcion',
      shippingMethodPrice: 'Precio de la opcion',
      addressSection: 'Direccion de envio',
      terms: 'Texto de terminos y condiciones',
      termsUrl: 'Enlace de terminos y condiciones',
      messagesSection: 'Mensajes de error',
      requiredError: 'Texto de campo obligatorio',
      genericError: 'Texto de error generico',
      genericErrorHelp: 'Se usa cuando un campo no tiene su propio texto de error.',
    },
    // Fixed names for the built-in fields' cards in the Designer. Keyed by FIELD KEY, not by the
    // merchant's label — the card names the field, and the label is a separate thing they edit.
    fieldNames: {
      first_name: 'Campo de nombre',
      last_name: 'Campo de apellido',
      phone: 'Campo de teléfono',
      address: 'Campo de dirección',
      address_2: 'Campo de dirección 2',
      province: 'Campo de provincia',
      city: 'Campo de ciudad',
      postal_code: 'Campo de código postal',
      email: 'Campo de correo electrónico',
      order_note: 'Campo de nota del pedido',
      newsletter: 'Campo de inscripción de marketing',
      terms: 'Campo de aceptación de términos',
    },
    blocks: {
      order_summary: 'Resumen del pedido',
      totals_summary: 'Resumen de totales',
      shipping_method: 'Metodo de envio',
      discount_code: 'Codigo de descuento',
      quantity_offers: 'Ofertas por cantidad',
      submit: 'Boton de envio',
      terms: 'Terminos y condiciones',
      newsletter: 'Suscripcion al boletin',
      discountHint:
        'Permite a tus clientes ingresar un codigo de descuento. Los codigos se validan al finalizar la compra.',
      quantityOffersHint:
        'Administra las ofertas y su diseno desde la pagina de Ofertas por cantidad.',
      shippingRatesHint: 'Crea y administra los metodos de envio en la pagina Metodos de envio.',
    },
    submit: {
      text: 'Texto del boton',
      textHelp: 'Usa {order_total} para mostrar el total del pedido',
      bgColor: 'Fondo',
      textColor: 'Color del texto',
      borderRadius: 'Radio del borde',
      fontSize: 'Tamano de fuente',
    },
    terms: {
      textColor: 'Color del texto',
      linkColor: 'Color del enlace',
      fontSize: 'Tamano de fuente',
      errorHelp:
        'Se muestra cuando el comprador envia sin aceptar. Dejalo vacio para usar el mensaje general de campo obligatorio.',
    },
    newsletter: {
      text: 'Texto de suscripcion',
      textColor: 'Color del texto',
      fontSize: 'Tamano de fuente',
    },
    addField: {
      button: 'Agregar campo, boton o imagen',
      modalTitle: 'Agregar elemento',
      add: 'Agregar',
      customText: 'Titulo o texto',
      customTextDesc: 'Texto o titulo personalizado',
      image: 'Imagen o GIF',
      imageDesc: 'Sube una imagen o GIF',
      whatsapp: 'Boton de WhatsApp',
      whatsappDesc: 'Boton para comprar o chatear por WhatsApp',
      textInput: 'Entrada de texto',
      textInputDesc: 'Campo de entrada de texto',
      dropdown: 'Campo desplegable',
      dropdownDesc: 'Menu con opciones',
      singleChoice: 'Campo de selección única',
      singleChoiceDesc: 'Opciones con seleccion unica',
      checkbox: 'Casilla de selección',
      checkboxDesc: 'Casilla para aceptar o confirmar',
      date: 'Selector de fecha',
      dateDesc: 'Campo para elegir una fecha',
      link: 'Boton de enlace',
      linkDesc: 'Boton que abre un enlace',
    },
    custom: {
      label: 'Etiqueta',
      placeholder: 'Texto de ejemplo',
      required: 'Obligatorio',
      showIcon: 'Mostrar icono del campo',
      iconLabel: 'Icono',
      connectTo: 'Conectar este campo a:',
      connectNothing: 'Nada',
      connect_first_name: 'Nombre',
      connect_last_name: 'Apellido',
      connect_phone: 'Telefono',
      connect_email: 'Email',
      connect_address: 'Direccion',
      connect_number: 'Numero de la calle',
      connect_address_2: 'Direccion 2',
      connect_locality: 'Barrio',
      connect_province: 'Provincia',
      connect_city: 'Ciudad',
      connect_postal_code: 'Codigo postal',
      connect_order_note: 'Nota del pedido',
      minLength: 'Longitud minima',
      maxLength: 'Longitud maxima',
      allowOnlyNumbers: 'Permitir solo numeros en este campo',
      prefixText: 'Texto de prefijo',
      prefixHelp: 'Texto que tus clientes no pueden cambiar.',
      errorText: 'Texto de error de valor invalido',
      options: 'Valores separados por coma',
      optionsHelp: 'Ingresa los valores separados por coma. Ejemplo: Rojo,Verde,Azul',
      content: 'Texto',
      shortcodesText:
        'Atajos: {order_total} para el total, {product_name} para el nombre del producto',
      align: 'Alineacion',
      align_left: 'Izquierda',
      align_center: 'Centro',
      align_right: 'Derecha',
      fontSize: 'Tamano de fuente',
      fontWeight: 'Grosor de fuente',
      weight_normal: 'Normal',
      weight_bold: 'Negrita',
      textColor: 'Color del texto',
      imageUrl: 'URL de la imagen',
      imageSize: 'Tamano de la imagen',
      btnText: 'Texto del boton',
      subtitle: 'Subtitulo del boton',
      phone: 'Tu numero de WhatsApp',
      phoneHelp: 'Importante: incluye el codigo de pais en el numero.',
      createOrder: 'Crear un pedido cuando se hace clic en el boton',
      message: 'Mensaje predefinido de WhatsApp',
      shortcodesWa:
        'Atajos: {page_url}, {products_summary_with_quantity}, {order_total}, {full_name}, {phone}, {email}, {full_address}, {order_note}',
      animation: 'Animacion del boton',
      anim_none: 'Ninguna',
      anim_pulse: 'Pulso',
      anim_shake: 'Vibracion',
      anim_bounce: 'Rebote',
      anim_tada: 'Tada',
      bgColor: 'Color de fondo',
      borderColor: 'Color del borde',
      borderRadius: 'Radio del borde',
      borderWidth: 'Grosor del borde',
      shadow: 'Sombra',
      url: 'URL del enlace',
    },
    preview: 'Vista previa',
  },
  // Shared page-state copy (empty / error / loading). One source for all eight pages —
  // see components/states.tsx.
  states: {
    errorTitle: 'No pudimos cargar esta seccion',
    errorText:
      'Revisa tu conexion e intenta de nuevo. Si el problema sigue, vuelve a abrir la aplicacion desde el panel de tu tienda.',
    retry: 'Reintentar',
    noDataTitle: 'Todavia no hay datos',
    noDataText: 'Las metricas apareceran aca cuando los compradores empiecen a usar tu formulario.',
  },
  tracking: {
    title: 'Pixeles de seguimiento',
    subtitle: 'Envia las conversiones de tus pedidos contra entrega a tus plataformas de anuncios',
    masterEnable: 'Activar el seguimiento',
    masterEnableHelp: 'Activa o desactiva el disparo de todos los pixeles configurados.',
    requireConsent: 'Requerir consentimiento antes de rastrear',
    requireConsentHelp:
      'Si esta activado, no se envia ningun evento a tus plataformas de anuncios: ni las vistas ni las compras. El formulario no puede pedir el consentimiento del comprador en la tienda, asi que activarlo desactiva todo el seguimiento.',
    addPixel: 'Agregar pixel',
    empty: 'Hace clic en "Agregar pixel" para empezar.',
    /**
     * What a pixel's row reports without being opened. Derived by `pixelStatus`, whose header
     * explains the ordering — `unsupported` before `failing` before `inactive`.
     */
    status: {
      active: 'Activo',
      inactive: 'Desactivado',
      incomplete: 'Falta configurar',
      failing: 'Con errores',
      unsupported: 'No se puede enviar',
    },
    pixelLabel: 'Pixel de {{provider}}',
    newPixelName: 'Nuevo pixel',
    provider: 'Plataforma',
    providerMeta: 'Meta (Facebook / Instagram)',
    providerTiktok: 'TikTok',
    providerGoogleAds: 'Google Ads',
    providerGa4: 'Google Analytics 4',
    pixelId: 'ID del pixel',
    pixelIdHelpMeta: 'Tu ID de pixel de Meta (solo numeros).',
    pixelIdHelpTiktok: 'Tu ID de pixel de TikTok.',
    pixelIdHelpGoogleAds: 'Tu ID de conversion de Google Ads (AW-XXXXXXXXX).',
    pixelIdHelpGa4: 'Tu ID de medicion de GA4 (G-XXXXXXX).',
    label: 'Etiqueta de conversion',
    labelHelp: 'Solo para Google Ads: la etiqueta de la accion de conversion.',
    enabled: 'Activo',
    noServerPathTitle: 'Google Ads no puede enviarse desde el servidor',
    noServerPath:
      'Las conversiones de Google Ads requieren la API de Google Ads (OAuth2 y token de desarrollador), que esta app no usa. Este pixel no se dispara. Para medir estos pedidos, agrega un pixel de Google Analytics 4 y vincula GA4 con Google Ads para importar la conversion.',
    accessToken: 'Token de acceso',
    accessTokenSet: 'Token guardado. Escribe uno nuevo para reemplazarlo.',
    accessTokenPlaceholder: 'Pegar token de acceso',
    accessTokenHelp: 'Se guarda cifrado y nunca se envia al navegador.',
    clearToken: 'Quitar token',
    testFail: 'No se pudo enviar el evento de prueba',
    failing: 'El ultimo envio del lado del servidor de este pixel fallo:',
    delete: 'Eliminar pixel',
    dupWarningTitle: 'Evita contar las conversiones dos veces',
    dupWarningBody:
      'Si ya usas la integracion nativa de Facebook o Google de Tiendanube, activa una sola fuente de conversiones. Para los pedidos contra entrega (que no pasan por el checkout nativo) deja que esta app reporte la conversion; de lo contrario, desactiva la fuente nativa para no duplicar.',
  },
  settings: {
    title: 'Configuracion',
    subtitle: 'Ajustes generales de la aplicacion',
    visibility: 'Visibilidad',
    visibilityHeading: 'Activa o desactiva tu formulario',
    visibilityHelp:
      'Puedes desactivar el formulario, o activarlo solo en las paginas de producto, solo en el carrito, o en ambos.',
    visDisabled: 'Desactivado',
    visCart: 'Solo carrito',
    visProduct: 'Solo paginas de producto',
    visBoth: 'Carrito y paginas de producto',
    visibilityEnabledNote: 'El formulario COD esta activo en tu tienda.',
    visibilityDisabledNote: 'El formulario esta desactivado y no aparecera en tu tienda.',
    cartModeTitle: 'Pedido en pagina de producto',
    cartModeHeading: 'Que incluye el pedido del formulario',
    cartModeHelp:
      'En una pagina de producto, pedir solo el producto que se esta viendo, o todo el carrito mas el producto actual (se agrega si aun no esta en el carrito).',
    cartModeProductOnly: 'Solo producto',
    cartModeProductAndCart: 'Producto + Carrito',
    thankYouTitle: 'Pagina de agradecimiento',
    thankYouHeading: 'Pagina posterior a la compra',
    thankYouHelp:
      'Elige que ven los compradores despues de hacer un pedido: una pagina personalizada, una redireccion a una URL, o un chat de WhatsApp con los datos del pedido.',
    thankYouEnable: 'Mostrar una pagina de agradecimiento personalizada',
    thankYouMode: 'Que ocurre despues de un pedido',
    thankYouModePage: 'Pagina personalizada',
    thankYouModeUrl: 'Boton a una URL',
    thankYouModeWhatsapp: 'Boton a WhatsApp',
    thankYouPageLabel: 'Contenido de la pagina (HTML)',
    thankYouPlaceholders:
      'Shortcodes: {order_id}, {order_number}, {order_total}, {products_summary_with_quantity}, {product_title}, {product_quantity}, {first_name}, {last_name}, {full_name}, {phone}, {email}, {address}, {address2}, {province}, {city}, {zip_code}, {order_note}, {shipping_rate_name}.',
    thankYouEditHtml: 'Editar el HTML',
    thankYouPreviewLabel: 'Vista previa en vivo',
    thankYouPreviewEmpty: 'Todavia no hay nada que mostrar: escribi o pega tu HTML arriba.',
    thankYouUrlLabel: 'URL de redireccion',
    thankYouUrlHelp:
      'Tras un pedido exitoso el comprador ve un boton que abre esta URL en una pestana nueva (ej. https://tu-sitio.com/gracias).',
    thankYouUrlRequired:
      'Agrega la URL que abre el boton, o elegi "Pagina personalizada" en su lugar.',
    thankYouUrlInvalid:
      'Escribi una direccion completa que empiece con https:// o una ruta de tu tienda que empiece con /.',
    thankYouPhoneLabel: 'Numero de WhatsApp',
    thankYouPhoneHelp: 'Incluye el codigo de pais, ej. 57 300 123 4567.',
    thankYouPhoneRequired:
      'Agrega el numero de WhatsApp que abre el boton, o elegi "Pagina personalizada" en su lugar.',
    thankYouPhoneInvalid: 'Escribi el numero con su codigo de pais, ej. 57 300 123 4567.',
    thankYouMessageLabel: 'Mensaje predefinido',
    thankYouWaPreview: 'Abre',
    templatesHeading: 'Empezar desde una plantilla',
    templatesHelp:
      'Elegi un diseno listo para usar e insertalo, o elegi "HTML propio" para escribir la pagina vos mismo. Para partir de un diseno, copia primero su HTML.',
    templateCustomHelp:
      'Escribi o pega tu propio HTML en "Editar el HTML", mas abajo. Para partir de uno de los disenos, seleccionalo arriba y usa "Copiar HTML".',
    templateCopy: 'Copiar HTML',
    templateCopied: 'HTML copiado. Pegalo en "HTML propio".',
    templateCopyFailed:
      'Tu navegador bloqueo la copia. Inserta la plantilla y despues cambia a "HTML propio" para editarla.',
    templateLanguage: 'Idioma de la plantilla',
    templateLanguageHelp:
      'Empieza en el idioma de tu tienda. Cambialo si te comunicas con tus compradores en otro; solo cambia el texto de la plantilla, no tu panel.',
    templateCallToConfirm: 'Llamo a los compradores para confirmar los pedidos',
    templateCallToConfirmHelp:
      'Cambia la linea de contacto de la plantilla. Se aplica al insertar; si lo cambias despues, volve a insertar la plantilla.',
    templateUse: 'Usar esta plantilla',
    templateCurrent: 'Plantilla actual:',
    templateCustom: 'HTML propio',
    templateNone: 'Ninguna todavia',
    templateInUse: 'En uso',
    templateReplaceTitle: 'Reemplazar el contenido actual',
    templateReplaceBody:
      'Ya escribiste contenido en la pagina de agradecimiento. Insertar esta plantilla lo reemplaza por completo y no se puede deshacer.',
    templateReplaceConfirm: 'Reemplazar',
    templateReplaceCancel: 'Cancelar',
    templateApplied: 'Plantilla insertada. Acordate de guardar.',
    templateClean: 'Minimalista',
    templateBold: 'Destacada',
    templateReceipt: 'Recibo',
    templateSoft: 'Amigable',
    templateSteps: 'Pasos',
  },
};

export type Translation = typeof es;
